<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="pa-0"
        text
        depressed
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
      >
        <span class="white--text checkout-h4" style="font-weight: 500">{{
          loggedUser.name
        }}</span>
        <v-icon class="ml-2" color="white">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-row class="py-6 px-4" no-gutters>
        <v-avatar v-if="$vuetify.breakpoint.mdAndUp" color="primary" size="56">
          <span class="white--text" style="font-size: 24px"
            >{{ loggedUser.name.slice(0, 1).toUpperCase()
            }}{{ loggedUser.lastname.slice(0, 1).toUpperCase() }}</span
          >
        </v-avatar>
        <v-col class="mx-5 mt-1">
          <v-row no-gutters>
            <span style="font-size: 14px; font-size: 20px"
              >{{ loggedUser.name }} {{ loggedUser.lastname }}</span
            >
          </v-row>
          <v-row class="mt-n1" no-gutters>
            <span style="font-size: 14px; color: rgba(0, 0, 0, 0.54)">{{
              loggedUser.email
            }}</span>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-divider></v-divider>
      </v-row>
      <v-row class="py-4" no-gutters>
        <v-list-item @click="logout">
          <v-list-item-title style="color: #626973 !important"
            ><v-icon color="primary" small class="mr-7">mdi-logout</v-icon
            >{{ $t("header.logout") }}</v-list-item-title
          >
        </v-list-item>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: ["loggedUser"],
  data: () => ({
    items: [
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me 2" },
    ],
  }),
  methods: {
    logout() {
      localStorage.removeItem("loggedUser");
      this.$store.commit("SET_LOGGED_USER", null);
      this.$store.dispatch("setPaymentOption", null);
    },
  },
};
</script>
